// extracted by mini-css-extract-plugin
module.exports = {"pageGroup":"_3a3qX"};